import {ConnectedHTMLElement} from "./ConnectedHtmlElement.js";
import {DispatchAction} from "../state/State.js";
import {GameActions} from "../state/GameReducer.js";
import {uiActions} from "../state/UiReducer.js";
import {PlayerKey} from "../assets/script/constants";

/**
 * @name PickWinnerModal
 * @class PickWinnerModal
 * @extends {ConnectedHTMLElement}
 * @description
 *
 */
export class PickWinnerModal extends ConnectedHTMLElement {
  constructor() {
    super();
  }

  /**
   * @param {SwucState} newState
   * @param {SwucState} oldState
   */
  stateUpdated(newState, oldState) {
    if (
      newState.ui.showPickWinnerModal.show !==
      oldState.ui.showPickWinnerModal.show
    ) {
      this.render();
    }
  }

  registerElementEvents() {
    const player = this.state.ui.showPickWinnerModal.player;
    const selectedReason = this.querySelector(
      "input[name='reason']:checked"
    );
    const closeBtn = this.querySelector("#close");

    closeBtn.addEventListener("click", () => {
      DispatchAction(GameActions.setWinner, {
        player,
        reason: selectedReason,
      });
    });

    const cancelBtn = this.querySelector("#cancel");
    cancelBtn.addEventListener("click", () => {
      DispatchAction(uiActions.togglePickWinnerModal, {
        show: false,
      });
    });
  }

  render() {
    const player = this.state.ui.showPickWinnerModal.player;
    if (this.state.ui.showPickWinnerModal.show === false) {
      this.innerHTML = "";
      return;
    }
    if (player === "none") {
      this.innerHTML = "";
      return;
    }
    const winnerBase = this.state[player].base;

    this.innerHTML = `
        <dialog class="modal winner-modal ${player === PlayerKey.top ? "rotate-180" : ""}" id="select-modal" ${this.state.ui.showPickWinnerModal.show === true ? "open" : ""}>
          <div class="modal-box">
            <h2 class="winner-modal-h2">Set winner</h2>
              <h3 class="winner-modal-h3">${winnerBase.name} wins</h3>
              <ul>
                <li>
                <label for="forfeit" class="reason">
                    <input type="radio" name="reason" value="forfeit" id="forfeit" class="radio" checked>
                    <span>Forfeit</span>
                  </label>
                </li>
                <li>
                <label for="time" class="reason">
                    <input type="radio" name="reason" value="time" id="time" class="radio">
                    <span>Out of time</span>
                  </label>
                </li>
              </ul>
              <h3 class="winner-modal-h3">No winner</h3>
              <ul>
                <li>
                <label for="draw" class="reason">
                    <input type="radio" name="reason" value="draw" id="draw" class="radio">
                    <span>Draw</span>
                  </label>
                </li>
              </ul>

            <div class="modal-action">
                <button id="close" class="btn btn-primary mt-2">Submit</button>
                <button id="cancel" class="btn mt-2">Cancel</button>
            </div>
          </div>
        </dialog>
      </div>`;
    this.registerElementEvents();
  }

  connectedCallback() {
    this.render();
  }
}
